export default {
  border: {
    thickness: '0.0625rem',
    style: 'solid',
  },
  padding: {
    top: '0.6875rem',
    right: '0.9375rem',
    bottom: '0.6875rem',
    left: '0.9375rem',
  },
  icon: {
    container: {
      width: '45px',
      height: '45px',
    },
  },
  outline: {
    width: '2px',
    style: 'solid',
  },
  error: {
    fontSize: '0.875rem', // 14px
    margin: {
      top: '0.25rem', //4px
    },
  },
  pulse: {
    timing: '.5s',
    ease: 'linear',
    thickness: '6px',
    fadeoutThickness: '12px',
  },
  mobileHeader: {
    padding: {
      top: '0.625rem',
      bottom: '0.625rem',
    },
    border: {
      thickness: '2px',
      style: 'solid',
    },
    button: {
      padding: '1.25rem',
    },
  },
};
